import { render, staticRenderFns } from "./TgTreeCard.vue?vue&type=template&id=1d2e3136"
import script from "./TgTreeCard.vue?vue&type=script&lang=js"
export * from "./TgTreeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports